export function fetchAssetIdFromSherbertUrl(assetUrl) {
    if (!assetUrl)
        return '';
    return assetUrl.split('/assets/')[1].split('/')[0];
}
//# sourceMappingURL=common.js.map